import { inject, Injectable } from '@angular/core';
import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  OAuthProvider,
  Auth,
} from 'firebase/auth';
import { SHARED_ENV } from '@trading-fe/shared';

@Injectable({ providedIn: 'root' })
export class SocialAuthService {
  private readonly env = inject(SHARED_ENV);
  private firebaseApp: FirebaseApp | null = null;
  private auth: Auth | null = null;

  private getFirebaseAuth(): Auth {
    if (this.auth) return this.auth;

    if (!this.env.firebaseAuth) {
      throw new Error('firebaseAuth config is missing in environment');
    }

    const appName = 'cube-broker-auth';
    const existing = getApps().find((a) => a.name === appName);
    this.firebaseApp = existing ?? initializeApp(this.env.firebaseAuth, appName);
    this.auth = getAuth(this.firebaseApp);
    return this.auth;
  }

  async signInWithGoogle(): Promise<string> {
    const auth = this.getFirebaseAuth();
    const provider = new GoogleAuthProvider();
    provider.addScope('email');

    const result = await signInWithPopup(auth, provider);
    const idToken = await result.user.getIdToken();
    return idToken;
  }

  async signInWithApple(): Promise<string> {
    const auth = this.getFirebaseAuth();
    const provider = new OAuthProvider('apple.com');
    provider.addScope('email');
    provider.addScope('name');

    const result = await signInWithPopup(auth, provider);
    const idToken = await result.user.getIdToken();
    return idToken;
  }
}
